<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6dTl9h/tc-custom/9781497652552.jpg?1705839757722" alt="This image is the cover for the book Mystery of the Sassafras Chair"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mystery of the Sassafras Chair
      </h1>
      <p class="bookDescription body article font2">
        <b>In the Carolina hills, a friend reaches out from beyond the grave</b><br/><br/>His parents dead, Timor is brought to America to live with his uncle in rural Appalachia. Although half-American, this shy young boy has never lived outside of Indonesia and finds it hard to adjust to life in the mountains. His only friend is Wiley Pendergrass, a mysterious old hermit who sees magic in discarded wood. For Timor, Wiley makes a ladder-back chair out of sassafras—a hard yellow wood with powers that will change Timor’s life forever.<br/> <br/>Accused by a local gem collector of stealing a precious box, Wiley pushes his ancient pickup as hard as he can to escape the police. Screaming around a hairpin mountain turn, he loses control and sails off the side of a cliff. Soon after, the chair begins speaking to Timor in Wiley’s voice. His friend may be gone, but with the help of a little Appalachian magic, Timor has a chance to clear Wiley’s name.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander Key
      </h2>
      
      <p class="authorDescription body article">Alexander Key (1904&ndash;1979) started out as an illustrator before he began writing science fiction novels for young readers. He has published many titles, including <I>Sprockets: A Little Robot</I>,<I> Mystery of the Sassafras Chair</I>,&#160;and&#160;<I>The Forgotten Door</I>,&#160;winner of the Lewis Carroll Shelf Award<I>.&#160;</I>Key&rsquo;s novel <I>Escape to Witch Mountain</I>&#160;was adapted for film in 1975, 1995, and 2009.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2dd2b6b1